
import React, { } from 'react';
import { BiUserCheck } from 'react-icons/bi';
import { HiKey } from 'react-icons/hi';
import { Link } from 'react-router-dom';
import { FaCopy } from "react-icons/fa";
import toast from 'react-hot-toast';
import { useAuth } from '../../context/UserContext';

function DeliveryCodesModal({ accessCode, deliveryCode, payment }) {
    const { user } = useAuth()

    const handleCopy = async () => {
        const link = `${window.location.origin}/payment/${payment?.transaction_reference}/delivery/confirm`;

        try {
            navigator.clipboard.writeText(link);
            toast.success("Link copied to clipboard!")
        } catch (err) {
            console.error('Failed to copy:', err);
        }
    };
    return (
        <>
            <label htmlFor="delivery-codes-modal" id="delivery-codes-open-btn" className="hidden">
                Open Delivery Codes
            </label>
            <input type="checkbox" id="delivery-codes-modal" className="modal-toggle" />

            <div className="modal">
                <div className="modal-box w-11/12 max-w-lg">
                    <label
                        htmlFor="delivery-codes-modal"
                        className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2"
                    >
                        ✕
                    </label>

                    <h3 className="font-bold text-lg text-center mb-4">Order Security Codes & Pages</h3>

                    <div className="space-y-4">
                        <div className="border rounded-lg p-4 bg-blue-50 dark:bg-blue-900/20">
                            <div className="flex items-start gap-3">
                                <HiKey className="h-6 w-6 text-blue-600 dark:text-blue-300 mt-0.5" />
                                <div>
                                    <h4 className="font-semibold text-blue-800 dark:text-blue-200">Agent Access Code</h4>
                                    <p className="text-sm text-gray-700 dark:text-gray-300 mt-1">
                                        Share this code only with authorized delivery personnel.
                                    </p>
                                    <div className="mt-2 flex gap-3 justify-between items-center">
                                        <span className="font-mono text-lg font-bold text-blue-900 dark:text-blue-100">
                                            {accessCode || '—'}
                                        </span>
                                        <div className="flex gap-2">
                                            <Link target='_blank' to={`/payment/${payment?.transaction_reference}/delivery/confirm`} className='btn btn-neutral btn-sm'>
                                                Agent Page
                                            </Link>
                                            <button
                                                onClick={handleCopy}
                                                className='btn btn-outline btn-sm'
                                                title="Copy link to clipboard"
                                            >
                                                <FaCopy size={16} />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {user?.is_admin ? (
                            <div className="border rounded-lg p-4 bg-green-50 dark:bg-green-900/20">
                                <div className="flex items-start gap-3">
                                    <BiUserCheck className="h-7 w-7 text-green-600 dark:text-green-300 mt-0.5" />
                                    <div>
                                        <h4 className="font-semibold text-green-800 dark:text-green-200">Customer Confirmation Code</h4>
                                        <p className="text-sm text-gray-700 dark:text-gray-300 mt-1">
                                            The customer must provide this code to confirm receipt.
                                        </p>
                                        <div className="mt-2 flex gap-3 justify-between">
                                            <span className="font-mono text-lg font-bold text-green-900 dark:text-green-100">
                                                {deliveryCode || '—'}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : null}
                    </div>

                    <div className="text-center text-sm text-gray-500 dark:text-gray-400 mt-4">
                        <p>These codes ensure secure handover of your order.</p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default DeliveryCodesModal;